import { render, staticRenderFns } from "./myShoppingCar.vue?vue&type=template&id=2bce4756&scoped=true&"
import script from "./myShoppingCar.vue?vue&type=script&lang=js&"
export * from "./myShoppingCar.vue?vue&type=script&lang=js&"
import style0 from "./myShoppingCar.vue?vue&type=style&index=0&id=2bce4756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bce4756",
  null
  
)

export default component.exports